import React from 'react';
// eslint-disable-next-line no-unused-vars
import { Animator } from 'wix-animations';
import PropTypes from 'prop-types';

import { ArrowDownIcon } from '../Icons/ArrowDownIcon';
import { ArrowUpIcon } from '../Icons/ArrowUpIcon';

import { PlusIcon } from '../Icons/PlusIcon';
import { MinusIcon } from '../Icons/MinusIcon';
import { IconWrapper } from '../style';

import { dataHooks, openButtonIconType, skins } from '../constants';
import { st, classes } from './AccordionItem.st.css';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';

class AccordionItem extends React.PureComponent {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  static displayName = 'AccordionItem';

  static propTypes = {
    title: PropTypes.node,
    children: PropTypes.node,
    openButtonIcon: PropTypes.oneOf([
      openButtonIconType.arrow,
      openButtonIconType.plus,
    ]),
    isOpen: PropTypes.bool,
    onToggle: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    skin: PropTypes.oneOf([skins.loose, skins.tight]),
    className: PropTypes.string,
  };

  state = {
    hover: false,
  };

  _onMouseLeave = (e) => {
    const { onMouseLeave } = this.props;

    this.setState({ hover: false });
    onMouseLeave && onMouseLeave(e);
  };
  _onMouseEnter = (e) => {
    const { onMouseEnter } = this.props;

    this.setState({ hover: true });
    onMouseEnter && onMouseEnter(e);
  };

  _renderOpenButton = () => {
    const { openButtonIcon, design, styleParams } = this.props;

    const commonProps = {
      dataHook: dataHooks.toggleButton,
    };

    const isArrow = openButtonIcon === openButtonIconType.arrow;
    return isArrow ? (
      <IconWrapper design={design} styleParams={styleParams}>
        <ArrowDownIcon {...commonProps} />
      </IconWrapper>
    ) : (
      <IconWrapper design={design} styleParams={styleParams}>
        {' '}
        <PlusIcon {...commonProps} />{' '}
      </IconWrapper>
    );
  };

  _renderCloseButton = () => {
    const { openButtonIcon, design, styleParams } = this.props;

    const commonProps = {
      dataHook: dataHooks.toggleButton,
    };

    const isArrow = openButtonIcon === openButtonIconType.arrow;

    return isArrow ? (
      <IconWrapper design={design} styleParams={styleParams}>
        <ArrowUpIcon {...commonProps} />
      </IconWrapper>
    ) : (
      <IconWrapper design={design} styleParams={styleParams}>
        <MinusIcon {...commonProps} />
      </IconWrapper>
    );
  };

  render() {
    const {
      title,
      isOpen,
      children,
      skin,
      className,
      isFirst,
      isLast,
      onToggle,
      settings,
    } = this.props;
    const { hover } = this.state;
    const firstClass = isFirst ? classes.first : '';
    const lastClass = isLast ? classes.last : '';
    const itemMainDivClass = st(
      classes.root,
      { hover, isOpen, skin },
      className,
      firstClass,
      lastClass,
    );

    return (
      <div className={itemMainDivClass}>
        <div data-hook={dataHooks.item}>
          <button
            onClick={onToggle}
            aria-expanded={isOpen}
            onMouseEnter={this._onMouseEnter}
            onMouseLeave={this._onMouseLeave}
            className={classes.btnQuestion}
            style={{ textAlign: settings.textAlignment }}
            type="button"
          >
            <div
              className={st(classes.header, firstClass, 'question-heading')}
              data-hook="header"
            >
              {title && (
                <div className={classes.title} data-hook="titleContainer">
                  {title}
                </div>
              )}
              <div
                className={classes.toggleButton}
                data-hook="toggle-accordion-wrapper"
                children={
                  isOpen ? this._renderCloseButton() : this._renderOpenButton()
                }
              />
            </div>
          </button>
          {settings.enableScrollAnimation ? (
            <Animator show={isOpen} height>
              <div data-hook="children" className={classes.children}>
                {children}
              </div>
            </Animator>
          ) : (
            isOpen &&
            <div
              data-hook="children"
              className={classes.children}
            >
              {children}
            </div>
          )}
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    ...state,
  };
}

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(AccordionItem));
